import React from 'react';
import { motion } from 'framer-motion';
import { Brain, GitBranch, ShieldAlert, HeartPulse, Users, Compass, Scale } from 'lucide-react';
export function CapabilityDomains() {
  const capabilities = [{
    icon: <Brain size={20} data-id="element-20" />,
    title: 'Reasoning Quality',
    desc: 'Evaluate claims, weigh evidence, identify contradictions, and process complexity with greater clarity.'
  }, {
    icon: <GitBranch size={20} data-id="element-21" />,
    title: 'Consequential Thinking',
    desc: 'Understand tradeoffs, second-order effects, and long-range outcomes before decisions are made.'
  }, {
    icon: <ShieldAlert size={20} data-id="element-22" />,
    title: 'Manipulation Resistance',
    desc: 'Detect propaganda, emotional framing, rhetorical deception, ideological capture, and disinformation.'
  }, {
    icon: <HeartPulse size={20} data-id="element-23" />,
    title: 'Emotional Regulation',
    desc: 'Improve stability under stress, reduce reactivity, and strengthen decision quality under pressure.'
  }, {
    icon: <Users size={20} data-id="element-24" />,
    title: 'Social Cooperation',
    desc: 'Navigate disagreement, handle conflict, and contribute constructively inside groups and institutions.'
  }, {
    icon: <Compass size={20} data-id="element-25" />,
    title: 'Self-Direction and Execution',
    desc: 'Build discipline, follow-through, planning ability, and the capacity to turn intent into action.'
  }, {
    icon: <Scale size={20} data-id="element-26" />,
    title: 'Leadership Responsibility',
    desc: 'Strengthen the ability to manage complexity, absorb dissent, and act responsibly at scale.',
    featured: true
  }];
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-27">
      <div className="mb-16" data-id="element-28">
        <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-4 block" data-id="element-29">
          Core Capabilities
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-30">
          The foundations of judgment and readiness
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-31">
        {capabilities.map((cap, index) => <motion.div key={cap.title} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: index * 0.05
      }} className={`bg-surface-card p-8 rounded-lg border border-line shadow-sm hover:shadow-md transition-shadow ${cap.featured ? 'md:col-span-2 lg:col-span-3 lg:w-2/3 mx-auto bg-surface-muted/50 border-navy/20' : ''}`} data-id="element-32">
            <div className={`w-10 h-10 rounded-md flex items-center justify-center mb-6 ${cap.featured ? 'bg-navy text-white' : 'bg-surface-muted text-navy-light border border-line'}`} data-id="element-33">
              {cap.icon}
            </div>
            <h3 className="text-xl font-heading font-bold text-ink-dark mb-3" data-id="element-34">
              {cap.title}
            </h3>
            <p className="text-ink-muted leading-relaxed" data-id="element-35">{cap.desc}</p>
          </motion.div>)}
      </div>
    </section>;
}